import { InkObject } from "./Object";

export class Void extends InkObject {
  public toString() {
    return "Void";
  }
}
